// extracted by mini-css-extract-plugin
export default {"menuButton":"MobileNav-module__menuButton_zkOoV","drawer":"MobileNav-module__drawer_fg0X4","MuiDrawer-paper":"MuiDrawer-paper"};